export default Object.freeze({
	// Netstamps
	RollTypeSorD: 'RollTypeSorD',
	RollTypeSorDExt: 'RollTypeSorDExt',
	Traditional: 'Traditional',
	Standard: 'Standard',
	Promotional: 'Promotional',
	Themed: 'Themed',
	PhotoLandscape: 'PhotoLandscape',
	PhotoPortrait: 'PhotoPortrait',
	Alternate: 'Alternate',
	PhotoLandscapeHS: 'PhotoLandscapeHS',
	PromoPaper20Netstamps: 'PromoPaper20Netstamps',
	ReturnAddress: 'ReturnAddress',

	// Envelopes
	EnvelopeInvitation: 'EnvelopeInvitation',
	EnvelopeGreeting: 'EnvelopeGreeting',
	EnvelopePersonal: 'EnvelopePersonal',
	EnvelopeMonarch: 'EnvelopeMonarch',
	Envelope9: 'Envelope9',
	Envelope10: 'Envelope10',
	Envelope11: 'Envelope11',
	Envelope12: 'Envelope12',

	// Labels
	Normal4x6: 'Normal4x6',
	Normal4x6CN22: 'Normal4x6CN22',
	Normal4X6CP72: 'Normal4X6CP72',
	NormalLeft: 'NormalLeft',
	NormalRight: 'NormalRight',
	GPPlus: 'GPPlus',
	GPPlusIntl: 'GPPlusIntl',
	NormalUps: 'NormalUps',
	NormalDhl: 'NormalDhl',
	NormalFedex: 'NormalFedex',
	NormalCN22: 'NormalCN22',
	NormalCP72: 'NormalCP72',
	NormalReturn: 'NormalReturn',
	NormalReceipt: 'NormalReceipt',

	// Certified Mail
	Sdc3610: 'Sdc3610',
	Sdc3710: 'Sdc3710',
	Sdc3910: 'Sdc3910',
	Sdc3930: 'Sdc3930',
	Sdc3810: 'Sdc3810',
	Sdc3830: 'Sdc3830',
});
